import { Grid, type GridSize, Typography } from "@mui/material";
import { type Control, type FieldValues, type Path } from "react-hook-form";
import { TextFieldWithControl } from "./text-field-with-control";

interface Props<T extends FieldValues> {
  control: Control<T>;
  fields: {
    name: Path<T>;
    label: string;
    type?: "text" | "number";
    sizes?: {
      xs?: GridSize;
      sm?: GridSize;
      md?: GridSize;
      lg?: GridSize;
    };
  }[];
  disabled?: boolean;
  label?: string;
}

export const TextInputGroup = <T extends FieldValues>({
  control,
  fields,
  disabled,
  label,
}: Props<T>) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sx={{ mb: -4 }}>
        <Typography variant="subtitle1">{label}</Typography>
      </Grid>

      {fields.map((field) => (
        <Grid key={field.name} item {...field.sizes}>
          <TextFieldWithControl
            key={field.name}
            control={control}
            name={field.name}
            label={field.label}
            disabled={disabled}
            type={field.type}
          />
        </Grid>
      ))}
    </Grid>
  );
};
